import $ from "jquery"
import { trace } from "rytm-helpers"
import { scrollToTarget } from './scroll-to'

const SELECTOR_FORM = 'form.validate-me'
const SELECTOR_SUBMIT = '.vm-submit'
const SELECTOR_FORMFIELD = '.formfield'
const SELECTOR_REQUIRED = '.required'
const CLASS_NAME_ERROR = "has-error"

// minimal password length
const MIN_PASSWORD_LENGTH = 1


const isEmail = ( txt ) => {
  let regex = /^([a-zA-Z0-9_\.\-\+])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/;
  return regex.test( txt );
}
// is safe string ?
const isSafe = ( txt) => {
  // let regex = /[\-\[\]\ /\{\}\(\)\*\<\>\+\?\.\\\^\$\|]/g;
  // let regex = /[\-\[\]\{\}\(\)\*\<\>\+\?\\\^\$\|]/g;
  let regex = /[\[\]\{\}\*\<\>\+\?\\\^\$\|]/g;
  return !regex.test( txt );
}

const setFormFieldInvalid = ( $field ) => {
  $field.addClass(CLASS_NAME_ERROR);
}
const setFormFieldValid = ( $field ) => {
  $field.removeClass(CLASS_NAME_ERROR);
}

const validateFormField = ( $it ) => {    
  let fieldValid = true;
  if ($it.hasClass("formfield-captcha")) {
    return true;
  }
  let $input = $it.find('input, textarea, select');
  let type = $input[0].tagName.toLowerCase();
  if ($input.attr('type')) {
    type = $input.attr('type');  
  }
  // trace("validate form element:", type);
  let value = $input.val();
  switch (type) {
    case "email":
      if (!isEmail(value)) {
        fieldValid = false;
        setFormFieldInvalid($it);
      } else {
        setFormFieldValid($it);
      }
      break;
    case "checkbox":
      let ch = $input.prop("checked");
      if (!ch) {
        fieldValid = false; 
        setFormFieldInvalid($it);
      }else {
        setFormFieldValid($it);
      }
      break;
    case "select":
      let unsafeSelect = !isSafe(value);
      if ((value.length == 0) || unsafeSelect || value == "0"){
        fieldValid = false; 
        setFormFieldInvalid($it);
      } else {
        setFormFieldValid($it);
      }
      break;
    case "radio":        
      let radioValid = false;
      let radioName = $input.attr("name");
      let $radioList = $it.find('input[name="' + radioName + '"]');
      $radioList.each( (index, el)=> {
        if ($(el).prop("checked") == true) {
          radioValid = true;
        }
      });
      if (!radioValid) {
        setFormFieldInvalid($it);
      }
      fieldValid = radioValid;
      break;
    case "file":
      if (value.length == 0) {
        fieldValid = false; 
        setFormFieldInvalid($it);
      } else {        
        if (!window.FileReader) {          
          setFormFieldValid($it);
        } else if ($input.data('sizelimit')) {     
          // check file size (data-sizelimit on input)
          let sizeLimit = parseInt($input.data('sizelimit'));
          let inp = $input.get(0);
          if (inp.files) {
            let file = inp.files[0];
            if (file) {
              if (file.size > sizeLimit) {
                fieldValid = false; 
                setFormFieldInvalid($it);
              }
            }
          }
        } else {
          setFormFieldValid($it);
        }
      }
      break;
    case "password":
      if (value.length < MIN_PASSWORD_LENGTH) {
        fieldValid = false; 
        setFormFieldInvalid($it);
      } else {
        setFormFieldValid($it);
      }
      break;
    default:
      let unsafe = !isSafe(value);
      if ((value.length == 0) || (unsafe)){
        fieldValid = false; 
        setFormFieldInvalid($it);
      } else {
        setFormFieldValid($it);
      }
      break;
  }
  return fieldValid;
}

const validateForm = ( $form, selector = SELECTOR_FORMFIELD + SELECTOR_REQUIRED ) => {
  // trace("validate form", $form);
  let formValid = true;
  // each <div> with "required" class name
  $form.find(selector).each( (index, el)=> {
    let $it = $(el);
    if (!validateFormField( $it )) {
      formValid = false;
    }
  });
  return formValid;
}

/**
 * ### EVENTS ###
 */
const onFormSubmitClick = (e) => {
  e.preventDefault()
  e.stopPropagation()
  const form = e.currentTarget.closest("form")
  if (form) {
    const result = validateForm( $(form) )
    if (result && form.checkValidity()) {
      form.submit()
    } else {
      // scroll up
      const errorFiled = form.querySelector(SELECTOR_FORMFIELD + "." + CLASS_NAME_ERROR)
      scrollToTarget(errorFiled, -100)
    }
  } 
}
const onFormChange = (e) => {
  validateForm($(e.currentTarget), SELECTOR_FORMFIELD + "." + CLASS_NAME_ERROR)
}

// ############
// ### init ###
// ############
export const initFormValidation = () =>  {
  // trace ("init form validator");
  $("body").on("change",  SELECTOR_FORM, onFormChange)
  $("body").on("click",  SELECTOR_FORM + ' ' + SELECTOR_SUBMIT, onFormSubmitClick)
}